module.exports = __webpack_public_path__ + "img/blik.4375a96b.svg";